export enum ErrorRoutes {
  HttpError = '/error/request',
  HasNotCompaniesError = '/error/user-companies',
  ForbiddenError = '/error/forbidden'
}

export enum ErrorEndpoint {
  HttpError = 'request',
  HasNotCompaniesError = 'user-companies',
  ForbiddenError = 'forbidden'
}
